import React, { Component } from 'react';
import NewsForm from './NewsForm';

export class CreateNews extends Component {
    static displayName = CreateNews.name;

    render() {
        return (
            <NewsForm newsId='0' formType='Create' />
        );
    }
}